import { render, staticRenderFns } from "./GenialGuardRegister.vue?vue&type=template&id=1acc71d7"
import script from "./GenialGuardRegister.vue?vue&type=script&lang=js"
export * from "./GenialGuardRegister.vue?vue&type=script&lang=js"
import style0 from "./GenialGuardRegister.vue?vue&type=style&index=0&id=1acc71d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports